import { useBusinessAccounts } from './scope.js';

export const BusinessSelector = () => {
  const { accounts, account, error, selectAccount, refresh } = useBusinessAccounts();
  if (error) return <div className="filter-bar"><span>Consulta de BMs indisponível.</span><button type="button" onClick={refresh}>Consultar BMs novamente</button></div>;
  if (accounts === null || accounts.length < 2) return null;
  return <div className="filter-bar">
    <label htmlFor="active-business">BM ativa nesta aba</label>
    <select id="active-business" value={account?.id ?? ''} onChange={(event) => selectAccount(event.target.value)}>
      {accounts.map((item) => <option key={item.id} value={item.id}>{item.displayName}</option>)}
    </select>
  </div>;
};
